var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-a i-0 bc-brand show-mob-only z-100"},[_c('div',{staticClass:"p-a pos-center tt-up d-f fd-c ta-c g w-100"},[_vm._m(0),_c('p',{staticClass:"link underline",on:{"click":_vm.goBack}},[_vm._v("Go back to previous page")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("This view isn't yet available on mobile. "),_c('br'),_vm._v("Please use desktop in the meantime.")])
}]

export { render, staticRenderFns }